import React from 'react';
import { FormTheme } from '../../types';

interface TextareaProps {
  id: string;
  label: string;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  theme: FormTheme;
  config: Record<string, any>;
}

export const Textarea: React.FC<TextareaProps> = ({
  id, label, required, value, onChange, onFocus, onBlur,
  error, disabled, theme, config,
}) => {
  const inputStyle = theme.inputStyle || 'outlined';

  return (
    <div className="hexaforms-field">
      <label htmlFor={id} className="hexaforms-label">
        {label}
        {required && <span className="hexaforms-required">*</span>}
      </label>
      <textarea
        id={id}
        value={value}
        onChange={e => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={config.placeholder}
        rows={config.rows || 4}
        className={`hexaforms-textarea hexaforms-input-${inputStyle}${error ? ' hexaforms-textarea-error' : ''}`}
      />
      {error && <div className="hexaforms-error">{error}</div>}
    </div>
  );
};
